import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {defaultGuards} from '../app-routing.module';
import {ConsumerServicesComponent} from './consumer-services.component';
import {ConsumerCreditReportComponent} from './reports/consumer-credit-report/consumer-credit-report.component';
import {MdsReportComponent} from './reports/mds-report/mds-report.component';
import {IfsReportComponent} from './reports/ifs-report/ifs-report.component';
import {EamlReportComponent} from './reports/eaml-report/eaml-report.component';
import {ConsumerUserGuard} from '../_guards/consumer-user.guard';

const consumerUserGuards = [...defaultGuards, ConsumerUserGuard];

const routes: Routes = [

  //Don't use "children" routes without a nested <router-outlet></router-outlet>
  //This module is lazy-loaded.  So every route in this routing module is a child route of consumer-services
  {path: '', pathMatch: 'full', component: ConsumerServicesComponent, canActivate: consumerUserGuards},
  {path: 'credit-report', pathMatch: 'full', component: ConsumerCreditReportComponent, canActivate: consumerUserGuards},
  {path: 'mds-report', pathMatch: 'full', component: MdsReportComponent, canActivate: consumerUserGuards},
  {path: 'ifs-report', pathMatch: 'full', component: IfsReportComponent, canActivate: consumerUserGuards},
  {path: 'enhanced-aml-report', pathMatch: 'full', component: EamlReportComponent, canActivate: consumerUserGuards}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConsumerServicesRoutingModule {}
